<template>
  <el-container class="finance-shell">
    <el-aside
      :width="collapsed ? '64px' : '236px'"
      class="finance-aside"
    >
      <div class="brand">
        <span class="brand-mark">元</span>
        <span v-if="!collapsed">财务管理</span>
      </div>
      <el-menu
        :default-active="route.path"
        :collapse="collapsed"
        router
        background-color="#172033"
        text-color="#c7d2e3"
        active-text-color="#fff"
      >
        <el-menu-item index="/finance/dashboard">
          <el-icon><Odometer /></el-icon>
          <template #title>财务概览</template>
        </el-menu-item>
        <el-sub-menu index="transactions">
          <template #title>
            <el-icon><Document /></el-icon>
            <span>成交管理</span>
          </template>
          <el-menu-item index="/finance/transactions">成交报告</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="receivables">
          <template #title>
            <el-icon><Money /></el-icon>
            <span>应收与收款</span>
          </template>
          <el-menu-item index="/finance/receivables">佣金应收</el-menu-item>
          <el-menu-item index="/finance/receipts">收款流水</el-menu-item>
          <el-menu-item index="/finance/other-income">其他收入</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="commission">
          <template #title>
            <el-icon><SetUp /></el-icon>
            <span>佣金规则</span>
          </template>
          <el-menu-item index="/finance/commission/plans">
            佣金方案
          </el-menu-item>
          <el-menu-item index="/finance/commission/branches">
            分部规则
          </el-menu-item>
          <el-menu-item index="/finance/commission/adjustments">
            佣金调整
          </el-menu-item>
        </el-sub-menu>
        <el-menu-item index="/finance/commission/teams">
          <el-icon><UserFilled /></el-icon>
          <template #title>小组与组长</template>
        </el-menu-item>
        <el-sub-menu index="expense">
          <template #title>
            <el-icon><Tickets /></el-icon>
            <span>支出管理</span>
          </template>
          <el-menu-item index="/finance/expenses">支出流水</el-menu-item>
          <el-menu-item index="/finance/expenses/categories">
            支出分类
          </el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="payout">
          <template #title>
            <el-icon><Wallet /></el-icon>
            <span>员工应发与发放</span>
          </template>
          <el-menu-item index="/finance/payouts/payables">
            员工应发
          </el-menu-item>
          <el-menu-item index="/finance/payouts/records">发放记录</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="account">
          <template #title>
            <el-icon><CreditCard /></el-icon>
            <span>资金账户</span>
          </template>
          <el-menu-item index="/finance/accounts">账户管理</el-menu-item>
          <el-menu-item index="/finance/accounts/flows">资金流水</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="settlements">
          <template #title>
            <el-icon><Calendar /></el-icon>
            <span>月度结账</span>
          </template>
          <el-menu-item index="/finance/settlements/monthly">
            结账与反结账
          </el-menu-item>
          <el-menu-item index="/finance/settlements/branches">
            分部结算
          </el-menu-item>
          <el-menu-item index="/finance/settlements/company">
            公司汇总
          </el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="reports">
          <template #title>
            <el-icon><DataAnalysis /></el-icon>
            <span>经营报表</span>
          </template>
          <el-menu-item index="/finance/reports/performance">
            个人业绩
          </el-menu-item>
          <el-menu-item index="/finance/reports/team-leaders">
            组长奖金
          </el-menu-item>
          <el-menu-item index="/finance/reports/branches">
            分部利润
          </el-menu-item>
          <el-menu-item index="/finance/reports/company">公司利润</el-menu-item>
          <el-menu-item index="/finance/reports/receivables">
            应收账款
          </el-menu-item>
          <el-menu-item index="/finance/reports/income-expense">
            收支明细
          </el-menu-item>
          <el-menu-item index="/finance/reports/accounts">
            账户对账
          </el-menu-item>
          <el-menu-item index="/finance/reports/exports">报表导出</el-menu-item>
          <el-menu-item index="/finance/reports/monthly-detail">月度业绩明细</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="settings">
          <template #title>
            <el-icon><Tools /></el-icon>
            <span>基础资料</span>
          </template>
          <el-menu-item index="/finance/settings/branches">
            分部维护
          </el-menu-item>
          <el-menu-item index="/finance/settings/employees">
            员工归属
          </el-menu-item>
          <el-menu-item index="/finance/settings/teams">小组成员</el-menu-item>
          <el-menu-item index="/finance/settings/payment-methods">
            支付方式
          </el-menu-item>
          <el-menu-item index="/finance/settings/profile">
            当前管理员
          </el-menu-item>
        </el-sub-menu>
        <el-menu-item index="/finance/system/logs">
          <el-icon><Memo /></el-icon>
          <template #title>操作日志</template>
        </el-menu-item>
        <el-menu-item index="/finance/system/migration">
          <el-icon><Upload /></el-icon>
          <template #title>历史迁移</template>
        </el-menu-item>
      </el-menu>
      <div class="aside-footer">
        <el-button
          text
          @click="logout"
        >
          <el-icon><SwitchButton /></el-icon>
          <span v-if="!collapsed">退出登录</span>
        </el-button>
      </div>
    </el-aside>
    <el-container>
      <el-header class="finance-header">
        <div class="header-left">
          <el-button
            text
            @click="store.commit('finance/toggleSidebar')"
          >
            <el-icon>
              <Fold v-if="!collapsed" />
              <Expand v-else />
            </el-icon>
          </el-button>
          <el-breadcrumb>
            <el-breadcrumb-item>财务中心</el-breadcrumb-item>
            <el-breadcrumb-item>
              {{ route.meta.title || '工作台' }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="header-right">
          <el-tag type="warning">{{ finance.currentMonth }} 结账月</el-tag>
          <span class="unit-name">
            {{ finance.unit?.name || `公司 ${finance.user?.unitId || ''}` }}
          </span>
          <el-avatar :size="30">{{ (userName || '管').slice(0, 1) }}</el-avatar>
          <span>{{ userName || '管理员' }}</span>
        </div>
      </el-header>
      <el-main class="finance-main"><router-view /></el-main>
    </el-container>
  </el-container>
</template>
<script setup>
import { computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { ElMessageBox } from 'element-plus'
const route = useRoute()
const router = useRouter()
const store = useStore()
const finance = computed(() => store.state.finance || {})
const collapsed = computed(() => finance.value.sidebarCollapsed)
const userName = computed(
  () => finance.value.user?.name || finance.value.user?.account || ''
)
onMounted(() => {
  if (!finance.value.user)
    store
      .dispatch('finance/loadSession')
      .catch(() => router.replace('/finance/login'))
})
const logout = async () => {
  try {
    await ElMessageBox.confirm('确认退出财务系统？', '提示')
  } catch {
    return
  }
  store.dispatch('finance/logout')
  router.replace('/finance/login')
}
</script>
<style scoped>
.finance-shell {
  min-height: 100vh;
  height: 100vh;
  background: #f4f6fa;
  overflow: hidden;
}
.finance-aside {
  background: #172033;
  transition: width 0.2s;
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-width: 0;
  overflow: hidden;
}
.brand {
  height: 64px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  font-weight: 600;
  padding: 0 18px;
  font-size: 17px;
  white-space: nowrap;
}
.brand-mark {
  background: #c22525;
  color: #fff;
  border-radius: 8px;
  padding: 7px 9px;
}
.finance-aside .el-menu {
  border-right: 0;
  flex: 1;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.finance-aside .el-menu::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.aside-footer {
  padding: 12px 16px;
}
.aside-footer .el-button {
  color: #b5c0d2;
  width: 100%;
  justify-content: flex-start;
}
.finance-header {
  height: 64px;
  background: #fff;
  border-bottom: 1px solid #e9edf3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 26px;
  flex: 0 0 64px;
}
.finance-shell > .el-container {
  min-width: 0;
  min-height: 0;
}
.header-left,
.header-right {
  display: flex;
  align-items: center;
  gap: 14px;
}
.unit-name {
  color: #64748b;
}
.finance-main {
  padding: 24px;
  max-width: 1800px;
  width: 100%;
  min-width: 0;
  min-height: 0;
  overflow: auto;
  box-sizing: border-box;
  margin: auto;
}
@media (max-width: 768px) {
  .finance-aside {
    position: fixed;
    z-index: 10;
    height: 100vh;
  }
  .finance-header {
    padding: 0 12px;
  }
  .header-right .unit-name,
  .header-right > span:last-child {
    display: none;
  }
  .finance-main {
    padding: 14px;
  }
}
</style>
